import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function CategoryCard({ category, photoCount, isAllCategories = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (isAllCategories) {
      navigate('/admin/photo-gallery/all');
    } else {
      navigate(`/admin/photo-gallery/${category.id}`, {
        state: { categoryName: category.name }
      });
    }
  };

  const cardStyle = {
    background: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: 8,
    padding: 20,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textAlign: 'center',
    minHeight: 150,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
  };

  const titleStyle = {
    fontFamily: 'var(--font-body)',
    fontSize: 16,
    fontWeight: 600,
    color: 'var(--color-text)',
    marginBottom: 4,
  };

  const countStyle = {
    fontFamily: 'var(--font-body)',
    fontSize: 13,
    color: 'var(--color-muted)',
  };

  const badgeStyle = {
    display: 'inline-block',
    padding: '3px 10px',
    borderRadius: 12,
    fontSize: 10,
    fontWeight: 600,
    letterSpacing: '0.05em',
    background: '#fb923c',
    color: '#fff',
    marginTop: 4,
  };

  return (
    <div
      style={cardStyle}
      onClick={handleClick}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
        e.currentTarget.style.transform = 'translateY(-2px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      <div style={titleStyle}>
        {isAllCategories ? 'All Categories' : category.name}
      </div>
      <div style={countStyle}>
        {photoCount} {photoCount === 1 ? 'photo' : 'photos'}
      </div>
      {!isAllCategories && category.is_default === 1 && (
        <span style={badgeStyle}>DEFAULT</span>
      )}
    </div>
  );
}
